import {ShortUser} from './ShortUser';
import {UserStatusType} from '../types/UserStatusType';
import type {Iso8601DateString} from '@fupa/fupa-ts-core';
import {Region} from './Region';

export class User extends ShortUser {
  readonly status: UserStatusType;
  readonly email: string | null;
  readonly privateAddress: boolean;
  readonly birthday: Iso8601DateString;
  readonly avatar: string | null;
  readonly createdAt: Iso8601DateString;
  readonly rewardPoints: number;
  readonly tickerCount: number;
  readonly region: Region;
  // TODO: Extend by required props
}
